import React, { useState } from "react";
import { Box, Container, Tabs, Tab, Paper } from "@mui/material";
import Alert from "@mui/material/Alert";
import AdminActions from "./AdminActions";
import AdminTaskList from "./TaskList";
import Flags from "./Flags";
import AdminEntries from "./AdminEntries";
import { useAccessControl } from "../context/AccessControlContext";

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function AdminPanel() {
  const { isAdmin, isLoading } = useAccessControl();
  const [activeTab, setActiveTab] = useState(0);

  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <div>Loading...</div>
      </Container>
    );
  }

  if (!isAdmin) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error">
          Access Denied: Only administrators can access this page.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            aria-label="admin tabs"
          >
            <Tab label="Entries" />
            <Tab label="Flags" />
            <Tab label="Actions" />
            <Tab label="Task List" />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <AdminEntries />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <Flags />
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <AdminActions />
        </TabPanel>

        <TabPanel value={activeTab} index={3}>
          <AdminTaskList />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default AdminPanel;
